import React from "react";

export const Promo = () => {
	// const { promo } = gameConfig;
	//
	// return <div className={`game-promo ${gameConfig.GameSystemName}`}>{promo}</div>;
	return <div></div>;
};
